import TestimonialQuote from '../elements/testimonialQuote';

export default class SliderController {
    constructor() {
        this.swiper = null;
        this.sliders = [];

        this.init();
    }

    init() {
        if (document.querySelectorAll('.swiper-container').length) {
            if (typeof Number.isNaN == 'undefined') {
                Number.isNaN = number => number === NaN;
            }

            import( /* webpackChunkName: "modules/slider" */ 'swiper').then(e => {
                this.swiper = e.Swiper;
                this.swiper.use([e.Navigation, e.Scrollbar, e.Pagination, e.Autoplay]);

                document.querySelectorAll('.swiper-container').forEach(container => {
                    if (container.classList.contains(`slider-initialized`)) {
                        return;
                    }

                    let settings = {
                        spaceBetween: 40,
                        grabCursor: true,
                        threshold: 10,
                        mousewheel: {
                            forceToAxis: true,
                        },
                        on: {},
                    };

                    if (container.parentElement.querySelector('.swiper-pagination')) {
                        if (container.querySelectorAll('.swiper-slide').length > 1) {
                            settings.pagination = {
                                el: container.parentElement.querySelector('.swiper-pagination'),
                                clickable: true,
                            };
                        } else {
                            container.parentElement.querySelector('.swiper-pagination').remove();
                        }
                    }

                    settings = Object.assign(settings, this.getSpecificOptions(container));

                    if (container.parentElement.querySelector('.indicator')) {
                        settings.on.sliderMove = () => {
                            container.parentElement.querySelector('.indicator').classList.add('hidden');
                        };
                    }


                    const slider = new this.swiper(container, settings);
                    container.classList.add(`slider-initialized`);

                    this.sliders.push(slider);
                });
            });
        }
    }

    getSpecificOptions(container) {
        let settings = {
            breakpoints: {},
        };

        settings.breakpoints[app.breakpoints.xs.size] = {
            spaceBetween: app.breakpoints.xs.gutter,
            slidesPerView: 1,
        };

        settings.breakpoints[app.breakpoints.sm.size] = {
            spaceBetween: app.breakpoints.sm.gutter,
            slidesPerView: 1.2,
        };

        settings.breakpoints[app.breakpoints.md.size] = {
            spaceBetween: app.breakpoints.md.gutter,
            slidesPerView: 2,
        };

        settings.breakpoints[app.breakpoints.lg.size] = {
            spaceBetween: app.breakpoints.lg.gutter,
            slidesPerView: 2.5,
        };

        if (container.classList.contains('homeHero')) {
            settings.navigation = false;
            settings.breakpoints = [];
            settings.spaceBetween = 0;
            settings.slidesPerView = 1;
            settings.autoplay = {
                delay: 5000
            };
        }

        if (container.classList.contains('carouselCards') || container.classList.contains('carouselTiles')) {
            settings.breakpoints[app.breakpoints.xs.size] = {
                spaceBetween: 20,
                slidesPerView: 1.1,
            };
            settings.breakpoints[app.breakpoints.sm.size] = {
                spaceBetween: 20,
                slidesPerView: 1.3,
            };
            settings.breakpoints[app.breakpoints.md.size] = {
                spaceBetween: 80,
                slidesPerView: 2.2,
            };
            settings.breakpoints[app.breakpoints.lg.size] = {
                spaceBetween: 80,
                slidesPerView: 2.5,
            };
            settings.breakpoints[app.breakpoints.xl.size] = {
                spaceBetween: 80,
                slidesPerView: 3.5,
            };
        }

        if (container.classList.contains('imageSwiperContainer')) {
            settings.breakpoints[app.breakpoints.xs.size] = {
                spaceBetween: 20,
                slidesPerView: 1,
            };
            settings.breakpoints[app.breakpoints.sm.size] = {
                spaceBetween: 20,
                slidesPerView: 1,
            };
            settings.breakpoints[app.breakpoints.md.size] = {
                spaceBetween: 80,
                slidesPerView: 1,
            };
            settings.breakpoints[app.breakpoints.lg.size] = {
                spaceBetween: 80,
                slidesPerView: 1,
            };
            settings.breakpoints[app.breakpoints.xl.size] = {
                spaceBetween: 80,
                slidesPerView: 1,
            };
            settings.navigation = {
                nextEl: container.parentElement.querySelector('.js-nextImage'),
                prevEl: container.parentElement.querySelector('.js-previousImage'),
            };
        }

        if (container.classList.contains('ticker')) {
            settings.speed = 30000;
            settings.autoplay = {
                delay: 1,
            };
            settings.loop = true;
            settings.slidesPerView = 'auto';
            settings.disableOnInteraction = true;
            settings.breakpoints[app.breakpoints.xs.size] = {
                spaceBetween: 20,
                slidesPerView: 'auto',
                speed: 10000,
            };
            settings.breakpoints[app.breakpoints.sm.size] = {
                spaceBetween: 20,
                slidesPerView: 'auto',
                speed: 10000,
            };
            settings.breakpoints[app.breakpoints.md.size] = {
                spaceBetween: 20,
                slidesPerView: 'auto',
                speed: 10000,
            };
            settings.breakpoints[app.breakpoints.lg.size] = {
                spaceBetween: 40,
                slidesPerView: 'auto',
            };
            settings.breakpoints[app.breakpoints.xl.size] = {
                spaceBetween: 40,
                slidesPerView: 'auto',
            };
        }

        if (container.classList.contains('testimonials')) {
            settings.speed = 1000;
            settings.autoplay = {
                delay: 6000,
            };
            settings.loop = true;
            settings.centeredSlides = true;
            settings.slidesPerView = 'auto';
            settings.slideToClickedSlide = true;
            settings.disableOnInteraction = true;
            settings.breakpoints[app.breakpoints.xs.size] = {
                spaceBetween: 15,
                slidesPerView: 'auto',
            };
            settings.breakpoints[app.breakpoints.sm.size] = {
                spaceBetween: 15,
                slidesPerView: 'auto',
            };
            settings.breakpoints[app.breakpoints.md.size] = {
                spaceBetween: 15,
                slidesPerView: 'auto',
            };
            settings.breakpoints[app.breakpoints.lg.size] = {
                spaceBetween: 30,
                slidesPerView: 'auto',
            };
            settings.breakpoints[app.breakpoints.xl.size] = {
                spaceBetween: 30,
                slidesPerView: 'auto',
            };
            settings.on = {};
            settings.on.slideChange = slider => {
                // get current active slide
                const slide = slider.slides[slider.activeIndex];

                let quote = '';
                let quotee = '';

                if (slide.dataset.quote) {
                    quote = slide.dataset.quote;
                }

                if (slide.dataset.quotee) {
                    quotee = slide.dataset.quotee;
                }

                this.setTestimonialQuote(slider, quote, quotee);
            }
        };

        if (container.classList.contains('relatedProducts')) {
            settings.speed = 1000;
            settings.autoplay = {
                delay: 5000,
            };
            settings.loop = false;
            settings.centeredSlides = false;
            settings.slidesPerView = 1.3;
            settings.slideToClickedSlide = true;
            settings.disableOnInteraction = true;

            settings.breakpoints[app.breakpoints.xs.size] = {
                spaceBetween: 20,
                slidesPerView: 1.3,
            };
            settings.breakpoints[app.breakpoints.sm.size] = {
                spaceBetween: 20,
                slidesPerView: 1.3,
            };
            settings.breakpoints[app.breakpoints.md.size] = {
                spaceBetween: 20,
                slidesPerView: 1.3,
                grabCursor: false,
                noSwipingClass: 'swiper-slide',
            };
            settings.breakpoints[app.breakpoints.lg.size] = {
                spaceBetween: 64,
                slidesPerView: 3,
            };
            settings.breakpoints[app.breakpoints.xl.size] = {
                spaceBetween: 64,
                slidesPerView: 3,
            };
        };

        if (container.classList.contains('relatedBlogArticles')) {
            settings.speed = 1000;
            settings.autoplay = {
                delay: 5000,
            };
            settings.loop = false;
            settings.centeredSlides = false;
            settings.slidesPerView = 1.3;
            settings.slideToClickedSlide = true;
            settings.disableOnInteraction = true;
            settings.breakpoints[app.breakpoints.xs.size] = {
                spaceBetween: 20,
                slidesPerView: 1.3,
            };
            settings.breakpoints[app.breakpoints.sm.size] = {
                spaceBetween: 20,
                slidesPerView: 1.3,
            };
            settings.breakpoints[app.breakpoints.md.size] = {
                spaceBetween: 20,
                slidesPerView: 1.3,
            };
            settings.breakpoints[app.breakpoints.lg.size] = {
                spaceBetween: 64,
                slidesPerView: 3,
            };
            settings.breakpoints[app.breakpoints.xl.size] = {
                spaceBetween: 64,
                slidesPerView: 3,
            };
        };

        if (container.classList.contains('lightboxImageSlider')) {
            settings.speed = 1000;
            settings.autoplay = false;
            settings.loop = true;
            // settings.slidesPerView = 1;
            settings.effect = "fade";
            settings.navigation = {
                nextEl: ".js-next",
                prevEl: ".js-prev",
            };
            settings.fadeEffect = {
                crossFade: true
            };
            settings.breakpoints = {};
        };

        if (container.classList.contains('experienceImages')) {
            settings.speed = 1000;
            settings.autoplay = false;
            settings.loop = true;
            settings.pagination = {
                el: ".swiper-pagination",
            },
            settings.slidesPerView = 1;
            settings.spaceBetween = 0;
            settings.breakpoints[app.breakpoints.xs.size] = {
                spaceBetween: 0,
                slidesPerView: 1,
            };
            settings.breakpoints[app.breakpoints.sm.size] = {
                spaceBetween: 0,
                slidesPerView: 1,
            };
            settings.breakpoints[app.breakpoints.md.size] = {
                spaceBetween: 0,
                slidesPerView: 1,
            };
            settings.breakpoints[app.breakpoints.lg.size] = {
                spaceBetween: 0,
                slidesPerView: 1,
            };
            settings.breakpoints[app.breakpoints.xl.size] = {
                spaceBetween: 0,
                slidesPerView: 1,
            };
            // settings.effect = "fade";
            // settings.navigation = {
            //     nextEl: ".js-next",
            //     prevEl: ".js-prev",
            // };
            // settings.fadeEffect = {
            //     crossFade: true
            // };
            settings.breakpoints = {};
        };

        return settings;
    }


    setTestimonialQuote(slider, quote, quotee) {
        // Set basics
        const container = document.querySelector('.testimonialQuoteContainer');

        // Set all current testimonials to be fading out and deleted
        container.querySelectorAll('.testimonialQuoteContent').forEach(exisitingQuote => {
            exisitingQuote.classList.add('fadingOut');

            setTimeout(() => {
                if (exisitingQuote) {
                    exisitingQuote.remove();
                }
            }, 1000);
        });

        // Insert the new quote right away
        let quoteElement = this.createTestimonialContent(quote, quotee);
        container.appendChild(quoteElement);

        setTimeout(() => {
            quoteElement.classList.add('fadingIn');
        }, 1);

        setTimeout(() => {
            quoteElement.classList.remove('fadingIn');
        }, 1000);
    }

    createTestimonialContent(quote, quotee) {
        let htmlElement = new TestimonialQuote();
        htmlElement.quote = quote;
        htmlElement.quotee = quotee;

        return htmlElement.generate();
    }
}